import React, { memo } from 'react';

const FooterWarehouseImport = () => {
    return (
        <a
            href='https://docs.vmass.vn/quan-ly/warehouse-import'
            target='_blank'
            className='mb-0 pl-2'
        >
            Hướng dẫn
        </a>
    );
};

export default memo(FooterWarehouseImport);
